import { useRouter } from "next/router";
import { useMemo, useState } from "react";

import { generateUrlArguments, timezone } from "@/utils";

import useForm from "@/hooks/useHookForm";
import useFormPayment from "@/hooks/useFormPayment";
import { useAppSelector } from "@/hooks/useRedux";

const useBookConsultationForm = () => {
  const router = useRouter();

  const { query } = router || {};

  let slug =
    typeof query?.slug === "string" ? query?.slug : query?.slug?.[0] || "";

  const { countryCodeData } = useAppSelector((state) => state.dashboard);
  const { data } = useAppSelector((state) => state.bootCamp);

  const isILAPage = slug === "indians-living-abroad";

  let countryCodeDefault = useMemo(
    () => countryCodeData?.default?.code || "+91",
    [countryCodeData]
  );

  if (isILAPage) {
    countryCodeDefault =
      countryCodeDefault === "+91" ? "+1" : countryCodeDefault;
  }

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const packData = data?.packData || {
    packageSlug: "nutrition-bootcamp-default",
  };

  const { nutritionGoalID } = packData;

  const defaultValues = useMemo(
    () => ({
      name: "",
      mobileCountryCode: countryCodeDefault,
      mobile: "",
      ...(nutritionGoalID ? { nutritionGoalID } : {}),
    }),
    [countryCodeDefault, nutritionGoalID]
  );

  const urlsArguments = generateUrlArguments();

  const { methods, resetData } = useForm({
    defaultValues,
  });

  const { isLoading, onBlur, onRequestCallback } = useFormPayment({
    methods,
    packData,
    urlsArguments,
    timezone,
    onSuccessCallback: () => {},
  });

  const { handleSubmit } = methods;

  const requestCallbackHandler = handleSubmit((formData) => {
    onRequestCallback(formData).then(() => {
      resetData();
      setIsFormSubmitted(true);
      setTimeout(() => {
        setIsFormSubmitted(false);
      }, 5000);
    });
  });

  return {
    isFormSubmitted,
    methods,
    isLoading,
    onBlur,
    requestCallbackHandler,
  };
};

export default useBookConsultationForm;
